import { useEffect } from 'react';
import { useStores } from 'stores/useStores';

export const useCheckSession = () => {
  const { sessionStore } = useStores();

  useEffect(() => {
    if (!sessionStore.sessionChecked) sessionStore.checkSession();
  }, [sessionStore, sessionStore.sessionChecked]);

  return { sessionStore };
};
